import React from 'react';
import styled from 'styled-components';
import {
  LockOutlined,
  DnsOutlined,
  VpnKeyOutlined,
  ReportProblemOutlined,
  VerifiedUserOutlined,
  EmailOutlined
} from '@mui/icons-material';

const PageContainer = styled.div`
  padding: 40px;
  max-width: 900px;
  margin: 0 auto;
  font-family: '"Proxima Nova"', sans-serif;
  line-height: 1.6;
`;

const Heading = styled.h1`
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
`;

const Section = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 40px;
`;

const IconWrapper = styled.div`
  margin-right: 25px;
  color: #007bff;
  margin-top: -5px; /* Align icon better with text */
`;

const SectionContent = styled.div`
  flex: 1;
`;

const SectionTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 10px;
`;

const Security = () => {
  return (
    <PageContainer>
      <Heading>Security Overview</Heading>
      <p>
        At Vaidhyamegha Pvt. Ltd., we take the security of your data and our services very seriously. Our DevOps Buddy platform is designed with a multi-layered security approach to protect your infrastructure and data.
      </p>

      <Section>
        <IconWrapper><LockOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Data Encryption</SectionTitle>
          <p><strong>Encryption in Transit:</strong> All data transmitted between you and the DevOps Buddy service is encrypted using industry-standard TLS (Transport Layer Security).</p>
          <p><strong>Encryption at Rest:</strong> Your sensitive data, including credentials and configuration, is encrypted at rest using AES-256 encryption.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><DnsOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Infrastructure Security</SectionTitle>
          <p>Our services are hosted on leading cloud infrastructure providers that are compliant with a wide range of security standards. We employ network firewalls, intrusion detection systems, and regular security audits to protect our infrastructure.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><VpnKeyOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Access Control</SectionTitle>
          <p>We enforce strict access control policies. Access to production environments is limited to authorized personnel only and is logged and monitored. Our application supports role-based access control (RBAC) to ensure users only have access to the resources they are authorized to view and manage.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><ReportProblemOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Incident Response</SectionTitle>
          <p>We have a dedicated incident response plan to address security events promptly. Our team is on standby to investigate, mitigate, and communicate any potential security incidents.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><VerifiedUserOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Vulnerability Management</SectionTitle>
          <p>We continuously scan our applications and infrastructure for vulnerabilities. We also encourage responsible disclosure from security researchers.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><EmailOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Reporting a Security Issue</SectionTitle>
          <p>If you believe you have discovered a security vulnerability in DevOps Buddy, please let us know by emailing us at <a href="mailto:security@vaidhyamegha.com">security@vaidhyamegha.com</a>. We appreciate your help in keeping our platform secure.</p>
        </SectionContent>
      </Section>
    </PageContainer>
  );
};

export default Security;
